import {LS, SS} from '@services/ls';
import {_CONST} from '@/constants/constants';
import {RoutesList} from '@/interfaces/interfaces';
import {adminService} from '@services/adminService';

export default function auth ({ next, store, to }) {
    const user = store.getters['main/getUser']
    const route = {
        fullPath: to.fullPath,
        hash: to.hash,
        name: to.name,
        params: to.params,
        path: to.path,
        query: to.query,
        meta: to.meta,
    }
    if (to.name !== RoutesList.auth) SS.set(_CONST.lsKeys.prevRoute, route)

    const isPassPermissions = adminService.hasPermissions(to.meta?.permissions)
    if (!user.loggedIn || !isPassPermissions) {
        return next({
            name: RoutesList.preloader
        })
    }

    return next()
}
